import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindFicheProduitRobeContent($id: String!)
{

    findFicheProduitRobeContent(id: $id){
    data{
      pageTitle {
        iv
      }
      brandId {
        iv
      }
      seoDescription {
        iv
      }
      seoKeywords {
        iv
      }
      seoThumbnail {
        iv {
          url
        }
      }
      firstImg{
        iv {
            fileName
            url
            fileSize
          }
      }
      productImgs{
        iv {
            fileName
            url
            version
            thumbnailUrl
            fileType
            fileSize
            mimeType
            lastModifiedBy
            fileVersion
            fileHash
          }
      }
      productVideoLink {
        iv
      }
      titleProduct{
        iv
      }
      subTitleProduct{
        iv
      }
      subTitleColor{
        iv
      }
      productModel{
        iv
      }
      productPrice{
        iv
      }

      ctaText{
        iv
      }
      ctaLink{
        iv
      }
      ctaStyle{
        iv
      }

      productDescription{
        iv
      }
      productAdvantage{
        iv
      }
      productAdvantageColor {
        iv
      }
      promo {
        iv{id}
      }

      showroom {
        iv{id}
      }
      mentions {
        iv
      }
    }
  }

}
`,
]);

export const BRAND_QUERY = gql([
    `
query findCornerMarqueContent($filter : String!) {
  queryCornerMarqueContents(top: 1, skip: 0, filter: $filter) {
    data {
      pageTitle {
        iv
      },
      brandId {
        iv
      }
    }
  }
}`,
]);
